import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles, Heart, Users, Award } from "lucide-react";

export default function About() {
  const [s, setS] = useState({});
  const [caseStudies, setCaseStudies] = useState([]);
  useEffect(() => {
    api.get("/settings").then(r => setS(r.data));
    api.get("/case-studies").then(r => setCaseStudies(r.data));
  }, []);
  return (
    <div data-testid="about-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="lumina-label mb-3">Tentang Kami</div>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 leading-[1.05]">Kami percaya, <em className="text-[#6B4BA3] italic font-normal">tiap orang</em> layak didengar.</h1>
            <p className="text-lg text-[#5C5870] leading-relaxed">{s.about}</p>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1200&auto=format&fit=crop" alt="Team" className="rounded-[2.5rem] w-full h-[520px] object-cover shadow-2xl shadow-[#6B4BA3]/15" />
          </div>
        </div>
      </section>

      <section className="lumina-container py-24">
        <div className="lumina-label mb-3">Nilai Kami</div>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mb-12 max-w-2xl">Profesional, hangat, dan inklusif.</h2>
        <div className="grid md:grid-cols-4 gap-6">
          {[
            { i: Heart, t: "Empati", d: "Mendengarkan tanpa menghakimi." },
            { i: Sparkles, t: "Profesional", d: "Psikolog berlisensi & berpengalaman." },
            { i: Users, t: "Inklusif", d: "Aman untuk semua latar belakang." },
            { i: Award, t: "Kualitas", d: "Standar etika tertinggi." },
          ].map(v => (
            <div key={v.t} className="lumina-card p-7">
              <div className="w-12 h-12 rounded-2xl bg-[#E8F0FA] flex items-center justify-center mb-4 text-[#6B4BA3]"><v.i className="w-5 h-5" /></div>
              <h3 className="font-serif text-2xl text-[#1A1728] mb-2">{v.t}</h3>
              <p className="text-sm text-[#5C5870]">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#E8F0FA]/40 py-24">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Profil Perusahaan</div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mb-6 max-w-3xl">Perjalanan kami.</h2>
          <p className="text-lg text-[#5C5870] max-w-3xl leading-relaxed">{s.company_profile}</p>
        </div>
      </section>

      <section className="lumina-container py-24" data-testid="case-studies-section">
        <div className="lumina-label mb-3">Studi Kasus</div>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mb-12">Dampak yang kami buat.</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {caseStudies.map(c => (
            <div key={c.id} className="lumina-card overflow-hidden" data-testid={`case-study-${c.id}`}>
              <div className="aspect-[16/9] overflow-hidden"><img src={c.image} alt={c.title} className="w-full h-full object-cover" /></div>
              <div className="p-6">
                <span className="lumina-label">{c.category}</span>
                <h3 className="font-serif text-2xl text-[#1A1728] mt-2 mb-3 leading-tight">{c.title}</h3>
                <p className="text-sm text-[#5C5870] mb-3">{c.summary}</p>
                <p className="text-sm text-[#5C5870] leading-relaxed">{c.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
